import React, { useState } from 'react';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Grid from '@material-ui/core/Grid';
import DateFnsUtils from '@date-io/date-fns';
import emailjs from 'emailjs-com';
import MuiAlert from '@material-ui/lab/Alert';
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from '@material-ui/pickers';

import { makeStyles } from '@material-ui/core/styles';
import Snackbar from '@material-ui/core/Snackbar';
import LinearProgress from '@material-ui/core/LinearProgress';



const useStyles = makeStyles((theme) => ({
  block: {
    display: 'none',
  },
}));


function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

function AlertError(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}


export default function DailogForm(props) {
  const classes = useStyles();
  // The first commit of Material-UI
  const [selectedDate, setSelectedDate] = React.useState(new Date());
  const [open, setOpen] = React.useState(false);
  const [openError, setOpenError] = React.useState(false);
  const [progress, setProgress] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const {
    Open,
    Close,
    property,
    Facing,
    AvName
  } = props



  const handleClick = () => {
    setOpen(true);
  };

  const handleClickError = () => {
    setOpenError(true);
  };

  const handleDateChange = (date) => {
    setSelectedDate(date);
  };
  
  const handleClose = () => {
    setOpen(false);
  };


  const handleChange = e => {
    // var {name, value} = e.target
    // setValues({
    //     ...values,
    //     [name]: value,

    // });
  }
  const handleEmailSubmit = e => {
    e.preventDefault();
    setProgress(true)
    setLoading(true)
    emailjs.sendForm(
      'service_b9v5hfs',
      'template_n577qqi',
      e.target,
      'user_c6L1p3GVRkDc5i4AlvRat')
      .then((result) => {
        console.log(result.text);
        handleClick(Alert);
        setProgress(false);
        setLoading(false);
      }, (error) => {
        console.log(error.text);
        handleClickError(AlertError);
        setLoading(false);
        setProgress(false);
      });

    e.target.reset()
  }

  return (
    <div>
      <Dialog open={Open} onClose={Close} aria-labelledby="form-dialog-title" scroll="paper" >
        <DialogTitle id="form-dialog-title">Contact Us</DialogTitle>
        <DialogContent dividers>
          {/* <DialogContentText>
          Thank you for choosing our services the power of deep roots.The Better Way to Buy Real Estate.
          </DialogContentText> */}

          <form onSubmit={handleEmailSubmit}>
            <Grid container spacing={3}>
              <Grid item xs={12} sm={6}>
                <TextField
                  autoFocus
                  required
                  id="Name"
                  name="name"
                  label="Name"
                  fullWidth
                  autoComplete="given-name"
                  onChange={handleChange}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  required
                  id="Phone"
                  name="phone"
                  label="Phone"
                  fullWidth
                  onChange={handleChange}
                />

              </Grid>
            </Grid>
            <Grid container spacing={3}>
              <Grid item xs={12} sm={6}>
                <TextField
                  required

                  margin="dense"
                  id="email"
                  name="email"
                  label="Email Address"
                  type="email"
                  fullWidth
                  onChange={handleChange}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                  <KeyboardDatePicker
                    disableToolbar
                    format="MM/dd/yyyy"
                    fullWidth
                    label="Date"
                    name="tour"
                    value={selectedDate}
                    onChange={handleDateChange}
                    KeyboardButtonProps={{
                      'aria-label': 'change date',
                    }}
                  />
                </MuiPickersUtilsProvider>
              </Grid>
              <Grid item >
                <TextField
                  id="message"
                  name="message"
                  label="Message"
                  fullWidth
                  autoComplete="given-name"
                  onChange={handleChange}
                  multiline
                // rows={2}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  required
                  autoFocus
                  id="property"
                  name="property"
                  label="property"
                  fullWidth
                  value={`${property + ',' + AvName + ',' + Facing}`}
                  onChange={handleChange}
                  className={classes.block}
                />
              </Grid>

            </Grid>


            {progress && <LinearProgress style={{ marginTop: "10px" }} />}
            <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
              <Alert onClose={handleClose} severity="success">
                Email has been sent to admin team. They will reach out to you shortly.
              </Alert>
            </Snackbar>
            <Snackbar open={openError} autoHideDuration={6000} onClose={handleClose}>
              <Alert onClose={handleClose} severity="error">
                Please try again!
              </Alert>
            </Snackbar>

            <DialogActions>
              <Button onClick={Close} color="primary">
                Cancel
              </Button>
              <Button color="primary" type="submit" disabled={loading}
              >
                Submit
              </Button>
            </DialogActions>
          </form >
        </DialogContent>
      </Dialog>
    </div>
  );
}